import React, { FC, useEffect } from 'react';
import { useUserContext } from '../../../../../providers/UserProvider';
import { Prompt } from '../../../../shared/Prompt';
import { useUserProfileUpdateMutation } from '../../../../../libs/graphql/baseAppAPI/mutations/__generated__/user-profile-update.mutation.generated';
import { APP_URLS, xTenantId } from '../../../../../consts';
import { Paragraph } from '../../../../shared/Paragraph';
import { Button } from '../../../../shared/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from '../../../../../hooks/snackbar';
import { useTranslations } from '../../../../../hooks/useTranslationsHelper';
import './styles.scss';

interface Props {
  cashierShowing: boolean;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

export const FirstDepositConsents: FC<Props> = (props) => {
  const { consents, userProfileId, fetchUserProfile } = useUserContext();
  const { t } = useTranslations();
  const { addSnack } = useSnackbar();
  const [userProfileUpdateMutation, { loading }] = useUserProfileUpdateMutation({
    onCompleted: fetchUserProfile,
    onError: () => {
      addSnack({
        type: 'error',
        message: t('errors.general'),
        theme: 'dark',
      });
    },
  });
  const navigate = useNavigate();
  const location = useLocation();
  const show = props.show && props.cashierShowing;

  useEffect(() => {
    if (!consents) return;

    if (!consents.lastInsolvencyReviewOnUtc) {
      props.setShow(true);
    } else {
      props.setShow(false);
    }
  }, [consents]);

  const onAcknowledge = async (): Promise<void> => {
    const now = new Date().toISOString();

    await userProfileUpdateMutation({
      variables: {
        userProfileId,
        xTenantId,
        userProfileUpdateInfo: {
          lastInsolvencyReviewOnUtc: now,
          lastAccountReviewOnUtc: now,
          lastFinancialLimitReviewOnUtc: now,
          lastAccountReviewInterval: 'P6M',
        },
      },
    });
  };

  const onClickSetLimit = (): void => {
    navigate(APP_URLS.myAccount.gamblingControls + '?edit=monetary', { state: { previousLocation: location } });
    props.onClose();
  };

  const onClickSGTools = (): void => {
    navigate(APP_URLS.myAccount.gamblingControls, { state: { previousLocation: location } });
    props.onClose();
  };

  const onClickPoFPolicy = (): void => {
    navigate('/pages/pof-policy');
    props.onClose();
  };

  return (
    <Prompt
      title={t('first-deposit-pocf-title')}
      PrimaryButton={{ text: 'ACKNOWLEDGE', onClick: onAcknowledge, disabled: loading }}
      show={show}
      className="ftd-consents"
      onClose={props.onClose}
    >
      <Paragraph>{t('first-deposit-pocf-p1')}</Paragraph>
      <div className="ftd-consents-links">
        <div className="ftd-consent-item">
          <Button type="button" variant="text" onClick={onClickSetLimit}>
            {t('first-deposit-pocf-link1')}
          </Button>
          <span className="ftd-consent-description">{t('first-deposit-pocf-link1-description')}</span>
        </div>
        <div className="ftd-consent-item">
          <Button type="button" variant="text" onClick={onClickSGTools}>
            {t('first-deposit-pocf-link2')}
          </Button>
          <span className="ftd-consent-description">{t('first-deposit-pocf-link2-description')}</span>
        </div>
        <div className="ftd-consent-item">
          <Button type="button" variant="text" onClick={onClickPoFPolicy}>
            {t('first-deposit-pocf-link3')}
          </Button>
          <span className="ftd-consent-description">{t('first-deposit-pocf-link3-description')}</span>
        </div>
      </div>
      <div className="ftd-consents-bottom-section">
        <Paragraph>{t('first-deposit-pocf-p2')}</Paragraph>
        <ul>
          <li>{t('first-deposit-pocf-li1')};</li>
          <li>{t('first-deposit-pocf-li2')}</li>
        </ul>
      </div>
    </Prompt>
  );
};
